import { put, call, takeEvery } from 'redux-saga/effects';
import * as _ from 'lodash';
import Api from '../../api/Api';
import * as types from './actionTypes.clientCodeRunner';
import * as errorSaga from '../errors/saga.errors';
import { IBaseAction, IPromiseParam } from '../base';
import { Environment } from '../../const/environment';
import store from '../../store';
import { IProjectApiCallInfo } from '../../models/IProjectApiCallInfo';

export interface IRememberProjectApiArgumentsParams {
    projectId: string;
    environment: Environment;
    param: object | string;
    projectApiName: string;
    result: string;
    historyKey: string;
    functionName?: string;
    callId: string;
}

export function* rememberProjectApiArguments({ projectId, param, projectApiName, result, functionName, historyKey, environment, callId }: IRememberProjectApiArgumentsParams) {
    try {
        yield put({ type: types.REMEMBER_PROJECT_API_PARAMS_OK, projectId, param, projectApiName, result, functionName, historyKey, callId });
        yield storeProjectApiHistory({ projectId, environment, historyKey, history: store.getState().clientCodeRunner?.paramsHistory[projectId] })
    } catch (error) {
        yield errorSaga.putError(error);
    }
}

export interface IRememberProjectApiResultParams {
    projectId: string;
    result: string;
    error: string;
    historyKey: string;
    environment: Environment;
    callId: string;
}

export function* rememberProjectApiResult({ projectId, result, error, historyKey, environment, callId }: IRememberProjectApiResultParams) {
    try {

        const index = _.findIndex(store.getState().clientCodeRunner?.paramsHistory[projectId], { callId });

        yield put({ type: types.REMEMBER_PROJECT_API_RESULT_OK, projectId, index, result, error, callId });
        yield storeProjectApiHistory({ projectId, environment, historyKey, history: store.getState().clientCodeRunner?.paramsHistory[projectId] })
    } catch (error) {
        yield errorSaga.putError(error);
    }
}
export interface IGetProjectApiHistoryParams extends IPromiseParam {
    projectId: string;
    environment: number;
    projectApiName: string;
    historyKey: string;
}
export function* getProjectApiHistory({ projectId, environment, projectApiName, historyKey, resolve, reject }: IGetProjectApiHistoryParams) {
    try {
        const apiParams = {
            projectId: projectId,
            deployment: environment,
            key: historyKey,
        }
        const storedValue = yield call(Api.getStudioData, apiParams);


        if (storedValue && storedValue.value) {
            const storedHistory = JSON.parse(storedValue.value);

            if (storedHistory) {
                yield put({ type: types.GET_PROJECT_API_HISTORY_OK, projectId, environment, storedHistory, projectApiName });
            }
        }
        if (resolve) {
            resolve();
        }
    } catch (error) {
        if (reject) {
            reject();
        }
        yield errorSaga.putError(error);
    }
}

export interface IStoreProjectApiHistoryParams {
    projectId: string;
    environment: Environment;
    history: IProjectApiCallInfo[];
    historyKey: string;
}

export function* storeProjectApiHistory({ projectId, environment, history, historyKey }: IStoreProjectApiHistoryParams) {
    if (_.isEmpty(history)) {
        return;
    }
    try {
        const historyString = JSON.stringify(history?.filter(el => el.historyKey === historyKey));
        const apiParams = {
            projectId: projectId,
            deployment: environment,
            key: historyKey,
            value: historyString
        };
        yield call(Api.storeStudioData, apiParams);
    } catch (error) {
        console.error(error);
        yield errorSaga.putError(error);
    }
}

export function* watch() {
    yield takeEvery<IRememberProjectApiArgumentsParams & IBaseAction>(types.REMEMBER_PROJECT_API_PARAMS_REQ, rememberProjectApiArguments);
    yield takeEvery<IRememberProjectApiResultParams & IBaseAction>(types.REMEMBER_PROJECT_API_RESULT_REQ, rememberProjectApiResult);
    yield takeEvery<IGetProjectApiHistoryParams & IBaseAction>(types.GET_PROJECT_API_HISTORY_REQ, getProjectApiHistory);
    yield takeEvery<IStoreProjectApiHistoryParams & IBaseAction>(types.STORE_PROJECT_API_HISTORY_REQ, storeProjectApiHistory);
}
